var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, TextField, Paper, Typography, Box, Snackbar, Alert, Link, CircularProgress, } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useServerValidation } from '../../shared/hooks/useServerValidation';
import { loginUser } from '../redux/authSlice';
import { PasswordField } from './PasswordField';
export const LoginForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [generalErrorMessage, setGeneralErrorMessage] = useState(null);
    const authStatus = useSelector((state) => state.auth.status);
    // Use the custom hook
    const { errors, setErrors, clearError, clearAllErrors } = useServerValidation();
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        clearAllErrors();
        setGeneralErrorMessage(null);
        try {
            const request = { username, password };
            yield dispatch(loginUser(request)).unwrap();
            navigate('/');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (error) {
            if (error === null || error === void 0 ? void 0 : error.errors) {
                // Server-side validation errors
                setErrors(error.errors);
            }
            else if (error === null || error === void 0 ? void 0 : error.message) {
                // General error
                setGeneralErrorMessage(error.message);
                setSnackbarOpen(true);
            }
            else {
                setGeneralErrorMessage('Login failed. Please check your username and password.');
                setSnackbarOpen(true);
            }
        }
    });
    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };
    return (_jsxs(Box, Object.assign({ sx: { width: '400px', maxWidth: '100%' } }, { children: [_jsx(Paper, Object.assign({ elevation: 3, sx: { padding: 3 } }, { children: _jsxs(Box, Object.assign({ sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    } }, { children: [_jsx(Typography, Object.assign({ variant: "h5", gutterBottom: true }, { children: "Login" })), _jsxs("form", Object.assign({ onSubmit: handleSubmit, style: { width: '100%' } }, { children: [_jsx(TextField, { variant: "outlined", margin: "normal", required: true, fullWidth: true, id: "username", label: "Username", name: "username", autoComplete: "username", value: username, onChange: (e) => {
                                        setUsername(e.target.value);
                                        clearError('username');
                                    }, error: !!errors.username, helperText: errors.username, inputProps: { 'data-testid': 'input-username' } }), _jsx(PasswordField, { value: password, onChange: (e) => {
                                        setPassword(e.target.value);
                                        clearError('password');
                                    }, label: "Password", id: "password", required: true, error: !!errors.password, helperText: errors.password, testId: "input-password" }), _jsx(Button, Object.assign({ type: "submit", fullWidth: true, variant: "contained", color: "primary", sx: { mt: 2 }, disabled: authStatus === 'loading', "data-testid": "button-submit", startIcon: authStatus === 'loading' && (_jsx(CircularProgress, { size: 20, color: "inherit" })) }, { children: authStatus === 'loading'
                                        ? 'Logging in...'
                                        : 'Login' })), _jsx(Box, Object.assign({ sx: { mt: 2 } }, { children: _jsxs(Typography, Object.assign({ variant: "body2", color: "textSecondary", align: "center" }, { children: ["Don't have an account? \u00A0", _jsx(Link, Object.assign({ variant: "body2", onClick: () => navigate('/signup') }, { children: "Sign Up" }))] })) })), _jsx(Box, Object.assign({ sx: { mt: 2 } }, { children: _jsx(Typography, Object.assign({ variant: "body2", color: "textSecondary", align: "center" }, { children: _jsx(Link, Object.assign({ variant: "body2", onClick: () => navigate('/recover-password') }, { children: "Forgot Password?" })) })) }))] }))] })) })), _jsx(Snackbar, Object.assign({ open: snackbarOpen, autoHideDuration: 6000, onClose: handleCloseSnackbar, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, "data-testid": "snackbar" }, { children: _jsx(Alert, Object.assign({ onClose: handleCloseSnackbar, severity: "error", sx: { width: '100%' }, "data-testid": "alert" }, { children: generalErrorMessage })) }))] })));
};
